import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { Grid } from '@mui/material'

import { useBonusActions } from '@/views/bonus-engine/hooks'
import { FormStatusType } from '@/enums/form-status.enum'
import BonusOfferSettingsComponent from './components/settings/index.component'

import BonusDetailsComponent from './components/settings/bonus-details.component'
import BonusTriggerComponent from './components/settings/bonus-trigger.component'
import UiFeedbackComponent from './components/ui-feedback/index.component'

import Enable from './components/settings/enable.component'
import useSteps, { StepProps } from './hooks/use-steps.hook'
import BonusAmountComponent from './components/settings/bonus-amount.component'

import RolloverSettingsComponent from './components/settings/rollover-settings.component'
import FreeSpinsComponent from './components/settings/free-spins/index.component'
import RestrictionsComponent from './components/settings/restrictions/index.component'

import DependenciesComponent from './components/settings/dependencies.component'
import useBonusEngineFormActions from './hooks/use-be-offers-actions.hook'
import SportRestrictions from './components/settings/restrictions/sports-restrictions/index.component'

import useReportsActions from '../reports/hooks/use-reports-actions.hooks'
// import EligibilityComponent from './components/settings/eligibility/index.component'

const BonusEngineOffersModule = () => {
  const {
    steps,
    handleResetForm,
    disableSubmit,
    handleCreateBonusOffer,
    handleOnChangeProvider,
    handleOnChangePMethods,
    bonusDetails,
    bonusAmount,
    bonusTrigger,
    rolloverSettings,
    freeSpins,
    restrictions,
    handleOnClickSetEnable,
    handleOnClickSetDisable,
    handleOnClickSetDiscardContribution,
    getProductsInitValues,
    getWagerTypeInitValues,
    getSportInitValues,
    providers,
    // eligibility,
    enable,
    dependencies,
    handleOnChangeBonusBundle,
    rolloverRestrictions,
    handleOnClickSetEnableRollover,
    handleOnClickSetDisableRollover,
    handleOnClickSetDiscardContributionRollover,
  } = useSteps()

  const { pathname } = useLocation()

  const {
    setBonusFormTypeAction,
    resetCurrentBonusAction,
    getBonusByIdOrCode,
  } = useBonusActions()

  const { getAllBonusesByBundleAction } = useBonusEngineFormActions()
  const { getAllProviders } = useReportsActions()

  const params = useParams()

  const param: any = { ...params }

  useEffect(() => {
    if (param.id) {
      if (pathname.split('/')[2] === 'duplicate') {
        setBonusFormTypeAction(FormStatusType.DUPLICATE)
      } else {
        setBonusFormTypeAction(FormStatusType.EDIT)
      }
      getBonusByIdOrCode({ id: param.id })
    } else {
      handleResetForm()
      setBonusFormTypeAction(FormStatusType.CREATE)
    }
  }, [param.id]) // eslint-disable-line

  useEffect(() => {
    getAllBonusesByBundleAction()
    getAllProviders()

    return () => {
      resetCurrentBonusAction()
    }
  }, []) // eslint-disable-line

  const getContent = (step: StepProps) => {
    let settings = <></>
    switch (step.label) {
      case 'generalSettings':
        settings = (
          <BonusDetailsComponent
            handleOnChange={bonusDetails.handleOnChange}
            state={bonusDetails.state}
          />
        )
        break

      case 'triggerSettings':
        settings = (
          <BonusTriggerComponent
            handleOnChange={bonusTrigger.handleOnChange}
            handleOnChangePMethods={handleOnChangePMethods}
            state={bonusTrigger.state}
          />
        )
        break

      case 'bonusAmountSettings':
        settings = (
          <BonusAmountComponent
            handleOnChange={bonusAmount.handleOnChange}
            state={bonusAmount.state}
            triggerState={bonusTrigger.state}
            bonusType={bonusDetails.state.type.value}
          />
        )
        break

      case 'rolloverSettings':
        settings = (
          <RolloverSettingsComponent
            handleOnChange={rolloverSettings.handleOnChange}
            state={rolloverSettings.state}
            bonusType={bonusDetails.state.type.value}
            triggerBy={bonusTrigger.state.triggerBy.value}
          />
        )
        break

      case 'freeSpinsSettings':
        settings = (
          <FreeSpinsComponent
            handleOnChange={freeSpins.handleOnChange}
            state={freeSpins.state}
          />
        )
        break

      case 'rolloverRestrictionsSettings':
        settings = (
          <SportRestrictions
            handleOnChange={rolloverRestrictions.handleOnChange}
            state={rolloverRestrictions.state}
            handleOnClickSetDisable={handleOnClickSetDisableRollover}
            handleOnClickSetEnable={handleOnClickSetEnableRollover}
            handleOnClickSetDiscardContribution={
              handleOnClickSetDiscardContributionRollover
            }
            getProductsInitValues={getProductsInitValues}
            getSportInitValues={getSportInitValues}
            getWagerTypeInitValues={getWagerTypeInitValues}
            bonusType={bonusDetails.state.type.value}
            rolloverRestrictions={true}
            title="bonusStepRolloverRestrictions"
          />
        )
        break

      case 'restrictionsSettings':
        settings = (
          <RestrictionsComponent
            handleOnChange={restrictions.handleOnChange}
            state={restrictions.state}
            handleOnClickSetDisable={handleOnClickSetDisable}
            handleOnClickSetEnable={handleOnClickSetEnable}
            handleOnClickSetDiscardContribution={
              handleOnClickSetDiscardContribution
            }
            getProductsInitValues={getProductsInitValues}
            getSportInitValues={getSportInitValues}
            getWagerTypeInitValues={getWagerTypeInitValues}
            bonusType={bonusDetails.state.type.value}
            handleOnChangeProvider={handleOnChangeProvider}
            providers={providers}
          />
        )
        break

      // case 'eligibility':
      //   settings = (
      //     <EligibilityComponent
      //       handleOnChangeWithValidations={
      //         eligibility.handleOnChangeWithValidations
      //       }
      //       handleOnChange={eligibility.handleOnChange}
      //       state={eligibility.state}
      //     />
      //   )
      //   break

      case 'dependencies':
        settings = (
          <DependenciesComponent
            handleOnChangeDependencies={handleOnChangeBonusBundle}
            state={dependencies.state}
          />
        )
        break

      case 'enableSettings':
        settings = (
          <Enable handleOnChange={enable.handleOnChange} state={enable.state} />
        )
        break
    }
    return {
      settings,
    }
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ height: '100%' }}>
          <BonusOfferSettingsComponent
            getContent={getContent}
            disableSubmit={disableSubmit}
            steps={steps}
            handleCreateBonusOffer={handleCreateBonusOffer}
            typeBonusOffer={bonusDetails.state.type.value}
          />
        </Grid>
      </Grid>
      <UiFeedbackComponent />
    </>
  )
}

export default BonusEngineOffersModule
